import { UserTypes } from 'types/GlobalTypes';

export const StatusCodes = {
  Success: 200,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
};

export const TypeColorsDictionary: Record<UserTypes | string, string> = {
  admin: 'black',
  analyst: 'dark-periwinkle',
  scout: 'kermit-green',
  trainer: 'ballPlayerBLue',
  coach: 'sky-blue',
  player: 'orange',
  stadiumtagger: 'stadiumTagger',
  cloudlivedashboard: 'cloudLiveDashboard',
  user: 'reddish-pink',
  other: 'reddish-pink',

  // status
  active: 'success',
  pending: 'primary',
  pendinguseraction: 'primary',
  pendingappsetup: 'primary',
  pendingemailsend: 'primary',
  inactive: 'secondary',
  abandoned: 'secondary',
  finalized: 'black',
};

export const PITCHING = 'Pitching';
export const HITTING = 'Hitting';
export const METRIC = 'Metric';
export const IMPERIAL = 'Imperial';

export const FLAGS_ARRAY: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789?!*#$@+-:/^%'.split('');

export const ServiceTypes = {
  ErrorHandler: Symbol('ErrorHandler'),
  ConfigurationService: Symbol('ConfigurationService'),
  AuthenticationService: Symbol('AuthenticationService'),
  apiServiceAxiosInstance: Symbol('apiServiceAxiosInstance'),
  footballApiBaseUrlAxiosInstance: Symbol('footballApiBaseUrlAxiosInstance'),
};

// Application UI permissions
export const AppPermissions = {
  PortalAccess: 'AFB.TeamPortalAccess@AFB',
  ManageUsers: 'AFB.TeamPortalAccess@AFB',
  ManageClients: 'AFB.TeamPortalAccess@AFB'
};

export const AppLinks = {
  About: 'https://login.trackman.com/Home/About',
  Terms: 'https://login.trackman.com/Home/TermsAndConditions',
  Support: 'https://trackman.zendesk.com/hc/en-us',
  Contact: 'https://support.trackman.com/hc/en-us',
  // Social
  Facebook: 'https://www.facebook.com/TrackManBB',
  Twitter: 'https://x.com/TrackManFB',
  LinkedIn: 'https://www.linkedin.com/company/trackman-',
};
